document.addEventListener("DOMContentLoaded", function () {
  const indexCounter = document.querySelector(".current-slide-counter > span");
  var splide = new Splide(".hire-steps__items", {
    type: "slide",
    perPage: 1,
    gap: "4px",
    padding: { left: "0", right: "var(--container-gutter)" },
    arrows: true,
    pagination: false,
    mediaQuery: 'min',
    breakpoints: {
      999: {
        destroy: true,
      },
    }
  });
  splide.mount();

  splide.on('moved', function (newIndex) {
    const newCurrentIndex = newIndex + 1;
    indexCounter.innerText = newCurrentIndex;
  });
});
